import { Dispatch, SetStateAction, useState } from 'react';
import useInsightSummaryForm, { InsightSummaryFormData } from './useInsightSummaryForm';
import { InsightSummaryStatusType, InsightSummaryType } from '../queries/useInsightsSummaryQuery';
import { InsightsAPI } from '../apis';
import useUserData from 'hooks/useUserData';

function useInsightSummaryModal({
  edit,
  insightSummary,
  setOpen,
  onUpdateCallback,
}: {
  edit?: boolean;
  insightSummary?: InsightSummaryType;
  onUpdateCallback?: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const { companyId } = useUserData();
  const { insightSummaryForm } = useInsightSummaryForm({
    insightSummary,
  });
  const [isSavingDraft, setSavingDraft] = useState(false);

  const onSubmit = async (values: InsightSummaryFormData & { isPublished: boolean }) => {
    if (!values.isPublished) {
      setSavingDraft(true);
    }

    if (edit) {
      try {
        await InsightsAPI.saveInsightSummary(companyId, {
          ...insightSummary,
          refArticleId: insightSummary?.refArticleId,
          title: values.title,
          description: values.description,
          status: values.isPublished
            ? InsightSummaryStatusType.PUBLISHED
            : InsightSummaryStatusType.REVIEW_PENDING,
        });
        setOpen(false);
        onUpdateCallback?.();
      } catch (error) {
        console.error('SAVE_INSIGHT_ERROR', error);
      }
    }
    setSavingDraft(false);
  };

  const handleSave = insightSummaryForm.handleSubmit((values) =>
    onSubmit({ ...values, isPublished: true }),
  );

  const handleSaveDraft = insightSummaryForm.handleSubmit((values) =>
    onSubmit({ ...values, isPublished: false }),
  );

  const handleClose = () => {
    setOpen(false);
  };

  return {
    isSavingDraft,
    insightSummaryForm,
    handleSave,
    handleSaveDraft,
    handleClose,
  };
}

export default useInsightSummaryModal;
